import { useContext } from 'react';

import { CompanyContext } from 'index';
import { CompanyLogo } from 'components/CompanyLogo';

import styles from './styles.module.scss';

export const DriverHeader = () => {
  const company = useContext(CompanyContext);

  return (
    <div className={styles.root}>
      <CompanyLogo src={company.logo} responsive={true} />
    </div>
  );
};
